<template>
    <div>
        <div v-if="page === 'comparePage'">
            <div
                v-if="!retiredConfirmation"
                class="status-panel"
                style="border-left: 10px solid #7F7F7F"
            >
                <div class="is-flex main-container">
                    <div
                        class="is-flex flex-align--center"
                        style="padding-right: 1rem;"
                    >
                        <div
                            class="icon-color"
                            style="margin: 1rem; font-size: 12px;"
                        >
                            <font-awesome-icon
                                size="3x"
                                :icon="['fas', 'question-circle']"
                            />
                        </div>
                        <div class="is-flex flex-direction--column flex-align--start">
                            <div
                                class="status-panel--header"
                                style="color: #000"
                            >
                                Review Potential Duplicates
                            </div>
                            <div
                                class="subtext-font-size"
                                style="color: #666"
                            >
                                All retirement requests are final and cannot be reverted.
                            </div>
                        </div>
                    </div>
                    <div
                      v-if="retirePendingNearMatchTransactions && retirePendingNearMatchTransactions.length"
                      class="is-flex flex-align--center grow border-left"
                      style="max-width: 61rem"
                    >
                        <font-awesome-icon
                          :icon="['fas', 'exclamation-triangle']"
                          size="3x"
                          class="exclamation-icon"
                        />
                        <span
                          class="subtext-font-size text-align--left"
                          style="padding-left: 1rem; color: #666"
                        >
                          <span>
                              There are currently pending near matches for State ID {{ retirePersonId }}. This State ID cannot be retired until all pending near matches are resolved.
                              See Transactions
                              <router-link
                                v-for="(transactionId, index) in retirePendingNearMatchTransactions"
                                :key="transactionId"
                                :to="{ path: `/personId/individualMatch/${transactionId}/details` }"
                                tag="span"
                                replace
                              >
                                <a>{{ transactionId }}</a>{{ index !== retirePendingNearMatchTransactions.length - 1 ? ', ' : '' }}
                              </router-link>
                          </span>
                        </span>
                    </div>
                    <div
                        v-if="differentPersonTypes || loadingIdError"
                        class="is-flex flex-align--center grow border-left"
                    >
                        <font-awesome-icon
                            :icon="['fas', 'exclamation-triangle']"
                            size="3x"
                          class="exclamation-icon"
                        />
                        <span
                            class="subtext-font-size"
                            style="padding-left: 1rem; color: #666"
                        >
                            <span v-if="loadingIdError">
                                {{ loadingIdErrorMsg }}
                            </span>
                            <span v-else>
                                The identifier retirement request is not authorized.
                                The identifiers are not the same person type and cannot be merged.
                            </span>
                        </span>
                    </div>
                    <div class="is-flex">
                        <div
                            class=
                                "status-panel--actions
                                is-flex
                                flex-direction--column
                                flex-justify--center
                                flex-align--start
                                subtext-font-size"
                        >
                            <a @click="returnToList" tabindex="0" role="button"
                                @keypress.enter.prevent="returnToList"
                            >
                                Cancel and Return to List
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-else
                class="status-panel"
                style="border-left: 10px solid #28A745"
            >
                <div class="is-flex">
                    <div class="is-flex flex-align--center grow">
                        <div
                            class="icon-color"
                            style="margin: 1rem; font-size: 12px;"
                        >
                            <font-awesome-icon
                                size="3x"
                                :icon="['fas', 'check-circle']"
                            />
                        </div>
                        <div class="is-flex flex-direction--column flex-align--start">
                            <div
                                class="status-panel--header"
                                style="color: #000"
                            >
                                Identifier Retired
                            </div>
                            <div
                                class="subtext-font-size"
                                style="color: #666"
                            >
                                All retirement requests are final and cannot be reverted.
                            </div>
                            <div
                                class="subtext-font-size"
                                style="color: #000000"
                            >
                                <span style="color: #666" >
                                    Identifier retired:
                                </span>
                                {{ retirePerson.firstName }} {{ retirePerson.lastName }}
                                    (ID:{{ retirePerson.personId }})
                                <span v-if="mergePerson">
                                    <span style="color: #666" >
                                        retired and merged to
                                    </span>
                                    {{ mergePerson.firstName }} {{ mergePerson.lastName }}
                                        (ID:{{ mergePerson.stateStudentId }})
                                </span>
                                <span v-else>
                                    <span style="color: #666" >
                                        retired with no merge.
                                    </span>
                                </span>
                            </div>
                            <div
                                class="subtext-font-size"
                                style="color: #000000"
                            >
                                <span style="color: #666" >
                                    Merge History Records:
                                </span>
                                {{ retiredResult.historyRecordsMerged === true ? 'Yes' : 'No' }}
                            </div>
                            <div
                                class="subtext-font-size max-char"
                                style="color: #000000"
                            >
                                <span style="color: #666" >
                                    Reason of Retirement:
                                </span>
                                {{ retiredResult.reference.retireReason }}
                            </div>
                        </div>
                    </div>
                    <div class="is-flex">
                        <div
                            class=
                                "status-panel--actions
                                is-flex
                                flex-direction--column
                                flex-justify--center
                                flex-align--start
                                subtext-font-size"
                        >
                            <a @click="returnToList" tabindex="0" role="button"
                                @keypress.enter.prevent="returnToList"
                            >
                                Return to List
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="page === 'confirmPage'"
            class="status-panel"
            style="border-left: 10px solid #ED7D31"
        >
            <div class="is-flex">
                <div class="is-flex flex-align--center grow">
                    <div
                        class="icon-color"
                        style="margin: 1rem; font-size: 12px;"
                    >
                        <font-awesome-icon
                            size="3x"
                            :icon="['fas', 'exclamation-circle']"
                        />
                    </div>
                    <div class="is-flex flex-direction--column flex-align--start">
                        <div
                            v-if="mergePerson"
                            class="status-panel--header"
                            style="color: #000"
                        >
                            Pending Retire ID with Merge Request
                        </div>
                        <div
                            v-else
                            class="status-panel--header"
                            style="color: #000"
                        >
                            Pending Retire ID with No Merge Request
                        </div>
                        <div
                            class="subtext-font-size"
                            style="color: #666"
                        >
                            All retirement requests are final and cannot be reverted.
                        </div>
                        <div
                            v-if="mergePerson"
                            class="subtext-font-size"
                            style="color: #000000"
                        >
                            {{ retirePerson.firstName }} {{ retirePerson.lastName }}
                                (ID:{{ retirePerson.stateStudentId }})
                            <span style="color: #666" >
                                will be merged to
                            </span>
                            {{ mergePerson.firstName }} {{ mergePerson.lastName }}
                                (ID:{{ mergePerson.stateStudentId }})
                        </div>
                        <div
                            v-else
                            class="subtext-font-size"
                            style="color: #000000"
                        >
                            {{ retirePerson.firstName }} {{ retirePerson.lastName }}
                                (ID:{{ retirePerson.stateStudentId }})
                            <span style="color: #666" >
                                will be retired with no merge.
                            </span>
                        </div>
                    </div>
                </div>
                <div class="is-flex">
                    <div
                        class=
                            "status-panel--actions
                            is-flex
                            flex-direction--column
                            flex-justify--center
                            flex-align--start
                            subtext-font-size"
                    >
                        <a @click="returnToList" tabindex="0" role="button"
                            @keypress.enter.prevent="returnToList"
                        >
                            Cancel and Return to List
                        </a>
                        <a @click="returnToDetails" tabindex="0" role="button"
                            @keypress.enter.prevent="returnToDetails"
                        >
                            Cancel and Return to Details
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheckCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faQuestionCircle,
} from '@fortawesome/pro-solid-svg-icons';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
  faCheckCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faQuestionCircle,
);

export default {
  mixins: [
    NotificationManager,
  ],
  props: {
    differentPersonTypes: {
      type: Boolean,
    },
    loadingIdError: {
      type: Boolean,
    },
    loadingIdErrorMsg: {
      type: String,
    },
    mergePerson: {
      type: Object,
    },
    page: {
      type: String,
      required: true,
    },
    retirePendingNearMatchTransactions: {
      type: Array,
    },
    retirePerson: {
      type: Object,
    },
    retiredConfirmation: {
      type: Boolean,
    },
    retiredResult: {
      type: Object,
    },
  },
  data() {
    return {
      retirePersonId: null,
    };
  },
  created() {
    this.retirePersonId = this.$route.query.retireId || this.retirePerson;
  },
  methods: {
    returnToDetails() {
      this.hideNotification();
      this.$emit('returnToDetails');
    },
    returnToList() {
      this.$router.push({
        name: 'PIRetireMerge',
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.main-container div:last-child
  margin-left: auto
.icon-color
  color: #BBBBBB
.exclamation-icon
  color: #ffc107
.border-left
  border-left: 1px solid #ccc;
  padding-left: 1rem;
.text-align--left
  text-align: left
.max-char
    max-width: 200ch
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
.status-panel
    border: 1px solid #bbb
    background-color: #f9f9f9
    box-shadow: 0 0 3px #aaa
    padding: 12px 16px 12px 0
.status-panel--header
    font-size: 20px
    margin-bottom: 0.25rem
.status-panel--actions
    border-left: 1px solid #ccc
    padding-left: 1rem
.subtext-font-size
    font-size: 12px
</style>
